import type { CognitoUser } from 'amazon-cognito-identity-js';

import { Auth } from 'aws-amplify';

let extensionAuthListenerInitialized = false;

/**
 * Sets up a listener for the extension's silent auth request.
 * The extension sends 'rask-extension:request-auth' when it needs to authenticate silently.
 * This responds with 'rask-extension:auth-response' containing the current user's tokens.
 */
export function setupExtensionAuthListener(): void {
  if (extensionAuthListenerInitialized) return;
  extensionAuthListenerInitialized = true;

  window.addEventListener('message', (event: MessageEvent) => {
    if (event.origin !== window.location.origin) return;
    if (event.source !== window) return;
    if (event.data?.action !== 'rask-extension:request-auth') return;

    const handleAuthRequest = async () => {
      try {
        const cognitoUser = (await Auth.currentAuthenticatedUser()) as CognitoUser;
        const session = cognitoUser.getSignInUserSession();

        if (!session) {
          window.postMessage({ action: 'rask-extension:auth-response', payload: null }, window.location.origin);
          return;
        }

        const idTokenPayload = session.getIdToken().payload;

        const payload = {
          refreshToken: session.getRefreshToken().getToken(),
          token: session.getIdToken().getJwtToken(),
          user: {
            id: (idTokenPayload.sub as string) || '',
            name: String(idTokenPayload.name || ''),
            picture: String(idTokenPayload.picture || ''),
          },
        };

        window.postMessage({ action: 'rask-extension:auth-response', payload }, window.location.origin);
      } catch {
        window.postMessage({ action: 'rask-extension:auth-response', payload: null }, window.location.origin);
      }
    };

    void handleAuthRequest();
  });
}
